import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import {
  LargedTuileComponent,
  TuileButtonProps,
} from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { ModalController } from '@ionic/angular/standalone';
import { P0003601SpeedChoiceComponent } from '../../../../P0003601/Component/p0003601-speed-choice/p0003601-speed-choice.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { P00037AutoChoiceComponent } from '../../../Component/p00037-auto-choice/p00037-auto-choice.component';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';
import { brandOverride } from '../../../../../../ECoSystemsHelper';

@Component({
  selector: 'app-p00037-card-electrolyseur-controle',
  templateUrl: './p00037-card-electrolyseur-controle.component.html',
  styleUrls: ['./p00037-card-electrolyseur-controle.component.scss'],
  imports: [LargedTuileComponent, TranslatePipe, SmallTuileComponent],
})
export class P00037CardElectrolyseurControleComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  private modalController = inject(ModalController);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  buttonModes: TuileButtonProps[] = [
    {
      id: 0,
      title: 'P00037.dashboard.off',
      icon: 'fa-kit fa-picto-off',
      color: 'color-red',
      status: 'inactive',
    },
    {
      id: 1,
      title: 'P00037.dashboard.manuel',
      icon: 'fa-kit fa-picto-on',
      color: 'color-green',
      status: 'inactive',
    },
    {
      id: 2,
      title: 'P00037.dashboard.auto',
      icon: 'fa-kit fa-picto-on',
      color: 'color-orange',
      status: 'active',

      onPress: () => {
        this.openManual().finally(() => {});
      },
    },
  ];

  buttons: TuileButtonProps[] = [
    {
      title: 'P00037.card.state.status.off',
      icon: 'fa-kit fa-picto-off',
      color: 'color-red',
      status: 'inactive',
    },
    {
      title: 'P00037.card.state.status.on',
      icon: 'fa-kit fa-picto-on',
      color: 'color-green',
      status: 'active',
    },
    {
      title: 'P00037.card.state.status.on',
      icon: 'fa-kit fa-picto-on',
      color: 'color-orange',
      status: 'active',
    },
  ];

  modes: any = [
    {
      title: '',
    },
    {
      title: '',
    },
    {
      title: 'P00037.dashboard.regulation.small',
    },
    {
      title: 'P00037.dashboard.horloge',
    },
    {
      title: 'P00037.dashboard.boost',
    },
    {
      title: '',
    },
  ];

  getButtonsMode(): TuileButtonProps[] {
    const modeFonctionnement =
      this.actionStack!.getValue('elCModeFonctionnement') ?? 0;

    let res = 'fa-kit fa-picto-programme';

    if (modeFonctionnement === 4) {
      res = 'fa-kit fa-picto-boost24';
    } else if (modeFonctionnement === 3) {
      res = 'fa-kit fa-picto-horloge';
    }

    this.buttonModes[2].icon = res;

    return this.buttonModes;
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.ELECTROLYSEUR_SALT,
      FunctionOnglet.PARAMETRE_REGLAGE,
      this.translateService.instant('P00037.dashboard.electrolyseur'),
    );
  }

  async openManual() {
    const modal = await this.modalController.create({
      component: P00037AutoChoiceComponent,
      componentProps: {
        value: this.actionStack!.getValue('elCModeFonctionnement') ?? 0,
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Controle,
        'elCModeFonctionnement',
        data.value,
      );
      this.actionStack!.commit();
    }
  }

  changeMode(event: number) {
    if (event != 2) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Controle,
        'elCModeFonctionnement',
        event,
      );
      this.actionStack!.commit();
    }
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly brandOverride = brandOverride;
}
